import { SIGNUP, VERIFY } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";

export const createUser = data => {
  return {
    type: SIGNUP.POST,
    payload: {
      ...data,
      endpoint: ENDPOINTS.USERS
    }
  };
};

export const resetUserSignUp = () => {
  return {
    type: SIGNUP.RESET
  };
};

// weirdly this is a post formatted like a GET
export const verifyUser = token => {
  return {
    type: VERIFY.POST,
    payload: {
      endpoint: `${ENDPOINTS.VERIFY}/${token}`
    }
  };
};
